const TRestaurantEditorScreen = {
    // English
    "enUS": {
        'NAME': 'Name',
        'DESCRIPTION': 'Description (Optional)',
        'COUNTRY': 'Country',
        'STATE': 'State',
        'CITY': 'City',
        'LOCATION': 'Address',
        'SAVE': 'Save',
        'SERVICE_TIME': 'Service Time',
        'SU': 'S',
        'MO': 'M',
        'TU': 'T',
        'WE': 'W',
        'TH': 'T',
        'FR': 'F',
        'SA': 'S',
    },
    // Spanish
    "esMX": {
        'NAME': 'Nombre',
        'DESCRIPTION': 'Descripción (Opcional)',
        'COUNTRY': 'País',
        'STATE': 'Estado',
        'CITY': 'Municipio',
        'LOCATION': 'Dirección',
        'SAVE': 'Guardar',
        'SERVICE_TIME': 'Horarios de servicio',
        'SU': 'D',
        'MO': 'L',
        'TU': 'M',
        'WE': 'M',
        'TH': 'J',
        'FR': 'V',
        'SA': 'S',
    }
}
export default TRestaurantEditorScreen;